import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { yellow } from '../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconStarComponent = ({ color = yellow.main, filled = false, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest} strokeWidth={1.5}>
      {filled ? <StarIcon /> : <StarOutlineIcon />}
    </SvgIcon>
  );
};

IconStarComponent.displayName = 'IconStar';

const IconStar = memo(IconStarComponent);

export default IconStar;
